import { Link } from "react-router-dom";
import { useParams } from "react-router";
import { isAuthenticated, isLoggedIn } from "../../Auth/isAuthenticated";
import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { settingsVideos } from "../../Config/Slider.js";
const TvShowsSeasons = ({ season, thumbnail, languages, title }) => {
  const { username, showid } = useParams();

  console.log(season);
  return (
    <div className="container-fluid mt-5">
      <h5 className="text-white fw-normal">Season {season.number}</h5>

      {!season.episode.length && (
        <h6 className="text-warning text-center text-normal fw-normal">
          No Episode in This Season
        </h6>
      )}
      <Slider {...settingsVideos} style={{ width: "100%" }}>
        {season.episode &&
          season.episode.map((movie, index) => {
            return (
              <div
                className="d-inline-flex flex-column m-2"
                key={index}
                style={{ maxWidth: "262px" }}
              >
                {/* <Link to={isAuthenticated()?`/${username}/tvshow/play/${showid}/${movie.video.split("-")[1]}`:isLoggedIn()?`/${username}/details/payment`:`/${username}/login`} className="text-decoration-none"> */}
                <Link
                  to={{
                    pathname: `/tvshow/play/${showid}/${
                      movie.lesson_id.video.split("/videos/")[1]
                    }`,
                    state: { season: season.episode },
                  }}
                  // to={`/tvshow/play/${showid}/${movie.lesson_id.video.split("/videos/")[1]}`}
                  className="text-decoration-none"
                >
                  <div>
                    <img
                      src={`${movie.lesson_id.thumbnail}`}
                      alt={`${movie.lesson_id.plot}`}
                      height="125px"
                      width="262px"
                      className="rounded"
                    />
                  </div>
                  <div>
                    <span className="text-light">{`${
                      movie.lesson_id.title ? movie.lesson_id.title : title
                    } ${movie.episodeNumber}`}</span>
                    <span className="text-light">
                      <span className="text-light">
                        &nbsp;&nbsp;
                        <small className="text-small">
                          ({movie.lesson_id.Languages.slice(0, 15) || "english"}
                          {movie.lesson_id.Languages.length > 15 && `...`})
                        </small>
                      </span>
                      {/* <small className="text-small">
                        &nbsp;&nbsp;{languages !== "" ? ` ${languages}` : ""}
                      </small> */}
                    </span>
                  </div>
                </Link>
              </div>
            );
          })}
      </Slider>
    </div>
  );
};

export default TvShowsSeasons;
